import React, { useEffect, useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import axios from "../../../axios";
import { useParams } from "react-router-dom";

export default function AddMemebers({
  communityDetails,
  setOpenSuccessfull,
  setChannel,
  items,
  setInAddingMode,
  isAddingModel,
}) {
  const [addMember, setAddMember] = useState({
    activeMember: "Teacher",
    addTeacher: false,
    addGroups: false,
    addStudent: false,
  });

  const { communityId } = useParams();

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [inProgress, setInProgress] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [selectedStudentListGroupsState, setSelectedListStudentGroupState] =
    useState([]);
  const [studentSectionOptionsState, setStudentSectionOptionsState] =
    useState(null);
  const [selectedStudentListClassState, setSelectedListStudentClassState] =
    useState([]);
  const [optionStudentGroupsState, setOptionStudentGroupsState] =
    useState(null);
  const [studentClassOptionState, setStudentClassOptionState] = useState(null);

  const [teacherList, setTeacherList] = useState([
    {
      label: "Select All",
      value: null,
    },
  ]);

  const [groupList, setGroupList] = useState([
    {
      label: "Select All",
      value: null,
    },
  ]);
  const [groupListForStudent, setGroupListForStudent] = useState([]);
  const [studentListByGroup, setStudentListByGroup] = useState([]);
  const [standardDetails, setStandardDetails] = useState({
    standardList: [],
    sectionList: [],
    studentList: [],
  });
  const { standardList, sectionList, studentList } = standardDetails;

  useEffect(() => {
    const getTeachers = async () => {
      let res = await axios.get(`/school/teacher/get`);
      if (res) {
        const teachers = res.data.data.map((item, index) => {
          return {
            label: item.name,
            value: item.id,
            profilePicture: item.profile_picture,
            memberType: "member",
          };
        });
        setTeacherList([...teacherList, ...teachers]);
      }
    };
    getTeachers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getGroupList = async () => {
    let res = await axios.get(
      `/group/filterForTeacher/teacherId/${teacher_id}?_page=1&_limit=20`
    );
    if (res) {
      const groups = res.data.data.map((item, index) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setGroupList([...groupList, ...groups]);
    }
  };

  const getGroupListForStudent = async () => {
    let res = await axios.get(
      `/group/filterForTeacher/teacherId/${teacher_id}?_page=1&_limit=20`
    );
    if (res) {
      const groups = res.data.data.map((item, index) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setGroupListForStudent(groups);
    }
  };

  const handleGroupSelection = async (selectedOption) => {
    setOptionStudentGroupsState(selectedOption);
    try {
      let res = await axios.get(
        `/group/getById/${selectedOption.value}?isFullFledged=true`
      );
      if (res) {
        const student = res?.data?.data?.member.map((item) => {
          return (
            item.member_type === "Student" && {
              label: item.member.name,
              value: item.member.id,
            }
          );
        });

        setStudentListByGroup(student.filter((i) => i !== false));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handelStandardSelection = async () => {
    // setSelectedListStudentGroupState([]);
    try {
      let res = await axios.get(`/school/standard/get`);
      if (res) {
        const standard = res?.data?.data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });

        setStandardDetails({
          ...standardDetails,
          standardList: standard,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handelStandardSelectionOption = async (selectedOption) => {
    setStudentClassOptionState(selectedOption);

    try {
      let res = await axios.get(`/school/section/get`);
      if (res) {
        const section = res?.data?.data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setStandardDetails({
          ...standardDetails,
          sectionList: section,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getStudentListByStandardAndSection = async (selectedOption) => {
    setStudentSectionOptionsState(selectedOption);
    try {
      let res = await axios.get(
        `/school/student/getList?standardId=${studentClassOptionState.value}&sectionId=${selectedOption.value}`
      );
      if (res) {
        const student = res?.data?.data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setStandardDetails({
          ...standardDetails,
          studentList: student,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddMember = () => {
    switch (addMember.activeMember) {
      case "Teacher":
        if (selectedOptions.length > 0) {
          setAddMember({ ...addMember, addTeacher: true });
        }
        break;
      case "Group":
        selectedOptionsGoups.length > 0 &&
          setAddMember({ ...addMember, addGroups: true });
        break;
      case "Student":
        (selectedStudentListGroupsState.length > 0 ||
          selectedStudentListClassState.length > 0) &&
          setAddMember({ ...addMember, addStudent: true });
        break;
      default:
        // do nothing
        break;
    }
  };

  const DropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "34px",
      width: "127px",
      borderRadius: " 5px",
      fontSize: "12px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: state.selectProps.menuWidth || "auto", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // serch dropdown
  const SearchDropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      border: "none",
      width: "35vw",
      borderRadius: " 5px",
      fontSize: "16px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "35vw",
      padding: "10px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      color: "#F77F00", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        marginRight: "10px",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for teahcer
  const ClassOptions = [
    { value: "admin", label: "Admin" },
    { value: "moderator", label: "Moderator" },
    { value: "member", label: "Member" },
  ];
  const [selectedClass, setSelectedClass] = useState({
    value: "member",
    label: "Member",
  });

  const Option = (props) => {
    const { data, isSelected, innerRef, selectProps } = props;

    let isChecked = isSelected;
    if (data.value === null) {
      isChecked = selectProps.value.length === teacherList.length - 1;
    }

    return (
      <div
        ref={innerRef}
        className={`option ${isSelected ? "selected" : ""}`}
        onClick={() => props.selectOption(props.data)}
      >
        <input
          type="checkbox"
          checked={isChecked}
          readOnly
          style={{ marginRight: "8px" }}
        />
        <span style={{ color: "#000000", fontSize: "14px", cursor: "pointer" }}>
          {data.label}
        </span>
      </div>
    );
  };

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === null)) {
      setSelectedOptions(teacherList.slice(1));
    } else {
      for (let i of selectedOptions) {
        i.memberType = selectedClass.value;
      }
      setSelectedOptions(selectedOptions);
    }
  };

  const handelHeaderSelectOption = (selectedOption) => {
    setSelectedClass(selectedOption);
    for (let i of selectedOptions) {
      i.memberType = selectedOption.value;
    }
    setSelectedOptions(selectedOptions);
  };

  const handelChangePurticularMemberType = (e, id) => {
    setSelectedOptions((prevOptions) => {
      const newOptions = [...prevOptions];
      const index = newOptions.findIndex((option) => option.value === id);
      if (index !== -1) {
        newOptions[index].memberType = e.value;
      }
      return newOptions;
    });
  };

  // this css for student class
  const DropdownStyleStudentsClass = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "231px",

      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "200px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for Groups
  const DropdownStyleStudents = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "350px",
      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "305px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const [selectedOptionsGoups, setSelectedOptionsGoups] = useState([]);

  const handleOptionChangeGroups = (selectedOptionsGoups) => {
    if (selectedOptionsGoups.some((option) => option.value === null)) {
      setSelectedOptionsGoups(groupList.slice(1));
    } else {
      setSelectedOptionsGoups(selectedOptionsGoups);
    }
  };

  useEffect(() => {
    if (
      selectedOptionsGoups.length > 0 ||
      selectedStudentListClassState.length > 0 ||
      selectedStudentListGroupsState.length > 0 ||
      selectedOptions.length > 0
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedOptionsGoups,
    selectedStudentListClassState,
    selectedStudentListGroupsState,
    selectedOptions,
  ]);

  const handelSubmit = async (e) => {
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }

    if (
      selectedStudentListClassState &&
      selectedStudentListClassState.length > 0
    ) {
      let students = selectedStudentListClassState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }
    if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }

    if (selectedOptions && selectedOptions.length > 0) {
      let teachers = selectedOptions.map((teacher) => {
        return { id: teacher.value, role: teacher.memberType };
      });
      members.push({ teachers: teachers });
    }

    let newCommunity = {
      user_id: teacher_id,
      community_name: communityDetails.name,
      short_description: communityDetails.description,
      members,
    };

    if (communityDetails.profilePicture) {
      const formData = new FormData();
      formData.append("name", communityDetails.profilePicture.name);
      formData.append(
        "uploadCommunityAttachment",
        communityDetails.profilePicture
      );
      try {
        const res = await axios.post(
          `/community/uploadAttachment/teacherId/${teacher_id}`,
          formData
        );
        newCommunity.profile_picture = res.data.data;
      } catch (error) { }
    }
    try {
      let res = await axios.post(`/community/create`, newCommunity);
      res && setInProgress(false);
      setOpenSuccessfull(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handelAddMemberInExisting = async (e) => {
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }

    if (
      selectedStudentListClassState &&
      selectedStudentListClassState.length > 0
    ) {
      let students = selectedStudentListClassState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    } else if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }

    if (selectedOptions && selectedOptions.length > 0) {
      let teachers = selectedOptions.map((teacher) => {
        return { id: teacher.value, role: teacher.memberType };
      });
      members.push({ teachers: teachers });
    }

    let newMembers = {
      user_id: teacher_id,
      members,
    };
    try {
      let res = await axios.post(
        `/community/addMember/${communityId}`,
        newMembers
      );
      res && setInProgress(false);
      setOpenSuccessfull(true);
    } catch (error) {
      console.log(error);
    }
  };

  // code for student radio butoons
  const [activeRadio, setActiveRadio] = useState("Groups");

  // code select the value as per SearchOptions

  return (
    <>
      <div className="RelativeContainer">
        <div className="addMemberHeader">Add Members</div>
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="d-flex gap-3 mt-2">
            <button
              onClick={(e) =>
                setAddMember({ ...addMember, activeMember: "Teacher" })
              }
              className={` ${addMember.activeMember === "Teacher"
                ? "active addMemberBtns_active"
                : "addMemberBtns"
                }`}
            >
              Teacher
            </button>
            <button
              onClick={(e) => {
                setAddMember({ ...addMember, activeMember: "Student" });
                getGroupListForStudent();
              }}
              className={` ${addMember.activeMember === "Student"
                ? "active addMemberBtns_active"
                : "addMemberBtns"
                }`}
            >
              Student
            </button>
            <button
              onClick={(e) => {
                setAddMember({ ...addMember, activeMember: "Group" });
                getGroupList();
              }}
              className={` ${addMember.activeMember === "Group"
                ? "active addMemberBtns_active"
                : "addMemberBtns"
                }`}
            >
              Groups / Classes
            </button>
          </div>

          <div>
            <button onClick={handleAddMember} className="addMemberAddBtns">
              <BsPlusCircle />
              &nbsp; Add
            </button>
          </div>
        </div>

        {addMember.activeMember === "Teacher" && (
          <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
            <div style={{ maxWidth: "300px", flex: 1 }}>
              <Select
                options={teacherList}
                value={selectedOptions}
                onChange={handleOptionChange}
                placeholder="Type here to search..."
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option }}
                styles={SearchDropdownStyle}
              />
            </div>

            <div>
              <Select
                styles={DropdownStyle}
                options={ClassOptions}
                value={selectedClass}
                onChange={(selectedOption) =>
                  handelHeaderSelectOption(selectedOption)
                }
                placeholder="Select"
                menuWidth={127}
              />
            </div>
          </div>
        )}

        {addMember.activeMember === "Student" && (
          <div className="mt-2">
            <div className="d-flex flex-wrap gap-3">
              <div className="gap-2 ">
                <input
                  onClick={(e) => {
                    setActiveRadio("Groups");
                    // setSelectedListStudentClassState([]);
                  }}
                  className="mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="option1"
                  checked={activeRadio === "Groups"}
                />
                <label className="radioBtn_css">Groups</label>
              </div>
              <div>
                <input
                  onClick={(e) => {
                    setActiveRadio("Class");
                    handelStandardSelection();
                  }}
                  className="mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="option2"
                  checked={activeRadio === "Class"}
                />
                <label className="radioBtn_css">Classes</label>
              </div>
            </div>
            <div className="Container_bothDropdowns ">
              {activeRadio === "Groups" ? (
                <div className="d-flex gap-2">
                  <div>
                    <Select
                      styles={DropdownStyleStudents}
                      options={groupListForStudent}
                      value={optionStudentGroupsState}
                      onChange={(selectedOption) =>
                        handleGroupSelection(selectedOption)
                      }
                      placeholder="Select Group"
                    />
                  </div>
                  <div>
                    <MultiSelect
                      options={studentListByGroup}
                      value={selectedStudentListGroupsState}
                      onChange={setSelectedListStudentGroupState}
                      className="custom-multiselect"
                      labelledBy={"Select"}
                      overrideStrings={{ selectSomeItems: "Select Students" }}
                    />
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-wrap gap-2">
                  <div>
                    <Select
                      styles={DropdownStyleStudentsClass}
                      options={standardList}
                      value={studentClassOptionState}
                      onChange={(selectedOption) =>
                        handelStandardSelectionOption(selectedOption)
                      }
                      placeholder="Select Class"
                    />
                  </div>
                  <div>
                    <Select
                      styles={DropdownStyleStudentsClass}
                      options={sectionList}
                      value={studentSectionOptionsState}
                      onChange={(selectedOption) =>
                        getStudentListByStandardAndSection(selectedOption)
                      }
                      placeholder="Select Section"
                      menuWidth={127}
                    />
                  </div>
                  <div>
                    <MultiSelect
                      options={studentList}
                      value={selectedStudentListClassState}
                      onChange={setSelectedListStudentClassState}
                      className="custom-multiselectNew"
                      labelledBy={"Select"}
                      overrideStrings={{ selectSomeItems: "Select Student" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {addMember.activeMember === "Group" && (
          <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
            <div style={{ maxWidth: "300px", flex: 1 }}>
              <Select
                options={groupList}
                value={selectedOptionsGoups}
                onChange={handleOptionChangeGroups}
                placeholder="Type here to search g..."
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option }}
                styles={SearchDropdownStyle}
              />
            </div>
          </div>
        )}

        <div className="Total_container_addedmember mt-3">
          {/* TEACHERS */}
          <div>
            {addMember.addTeacher && (
              <div className="">
                <div className="addedMember">Added Members</div>

                <div className="teacher_header mt-2">TEACHERS</div>

                <div>
                  {selectedOptions.length > 0 &&
                    selectedOptions.map((option) => (
                      <div className="d-flex">
                        <div
                          key={option.id}
                          className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                        >
                          <div className="teachersNameImg d-flex justify-content-center">
                            <div className="NamesFirstLetter">
                              {option.label.substr(0, 1)}
                            </div>
                          </div>
                          <div className="names_tacher">
                            <div>{option.label}</div>
                          </div>
                        </div>

                        <div>
                          <div className="mt-1">
                            <Select
                              styles={DropdownStyle}
                              options={ClassOptions}
                              value={{
                                value: option.memberType,
                                label: option.memberType,
                              }}
                              onChange={(e) =>
                                handelChangePurticularMemberType(
                                  e,
                                  option.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>

          {/* student  */}
          <div className="mt-1">
            {addMember.addStudent && (
              <div>
                <div className="teacher_header">STUDENTS</div>

                <div>
                  {selectedStudentListGroupsState.map((option) => (
                    <div
                      key={option.id}
                      className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                    >
                      <div className="teachersNameImg d-flex justify-content-center">
                        <div className="NamesFirstLetter">
                          {option.label.substr(0, 1)}
                        </div>
                      </div>
                      <div className="names_tacher">
                        <div>{option.label}</div>
                      </div>
                    </div>
                  ))}

                  {selectedStudentListClassState.map((option) => (
                    <div
                      key={option.id}
                      className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                    >
                      <div className="teachersNameImg d-flex justify-content-center">
                        <div className="NamesFirstLetter">
                          {option.label.substr(0, 1)}
                        </div>
                      </div>
                      <div className="names_tacher">
                        <div>{option.label}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* GROUPS  */}
          <div className="mt-1">
            {addMember.addGroups && (
              <div>
                <div className="teacher_header">GROUPS</div>

                <div>
                  {selectedOptionsGoups.map((option) => (
                    <div
                      key={option.id}
                      className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                    >
                      <div className="teachersNameImg d-flex justify-content-center">
                        <div className="NamesFirstLetter">
                          {option.label.substr(0, 1)}
                        </div>
                      </div>
                      <div className="names_tacher">
                        <div>{option.label}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="absoluteContainer">
          {!isAddingModel ? (
            <div className="innerFlexContainer">
              <div className="pageNumber">2/2</div>
              <div className="d-flex gap-4">
                <button
                  onClick={(e) => {
                    setChannel({
                      addMembers: false,
                    });
                  }}
                  className="Previous_Btn_channel"
                >
                  Previous
                </button>
                {!inProgress ? (
                  <button
                    type="submit"
                    disabled={isValid}
                    onClick={(e) => handelSubmit(e)}
                    className="btn btn-danger create_Btn"
                  >
                    Create
                  </button>
                ) : (
                  <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
                )}
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-end">
              <div className="d-flex gap-4">
                <button
                  onClick={(e) => {
                    setInAddingMode(!isAddingModel);
                  }}
                  className="Previous_Btn_channel"
                >
                  Discard
                </button>
                {!inProgress ? (
                  <button
                    type="submit"
                    disabled={isValid}
                    onClick={(e) => handelAddMemberInExisting(e)}
                    className="btn btn-danger create_Btn"
                  >
                    Save
                  </button>
                ) : (
                  <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
